import { render } from "./descriptions.vue?vue&type=template&id=2edb2084&scoped=true&ts=true"
import script from "./descriptions.vue?vue&type=script&lang=ts"
export * from "./descriptions.vue?vue&type=script&lang=ts"

import "./descriptions.vue?vue&type=style&index=0&id=2edb2084&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edb2084"]])

export default __exports__